import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { MarketingFlow } from "../../marketing.types";

export const requestGetMarketingFlows = async (): Promise<MarketingFlow[]> => {
  return await instance.get(ApiRoutesMarketing.Flows);
};
